import { render, staticRenderFns } from "./intelligentAnswering.vue?vue&type=template&id=15fcee3c&scoped=true&"
import script from "./intelligentAnswering.vue?vue&type=script&lang=js&"
export * from "./intelligentAnswering.vue?vue&type=script&lang=js&"
import style0 from "./intelligentAnswering.vue?vue&type=style&index=0&id=15fcee3c&prod&scoped=true&lang=scss&"
import style1 from "./intelligentAnswering.vue?vue&type=style&index=1&id=15fcee3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fcee3c",
  null
  
)

export default component.exports